<div>
  <app-header-bar></app-header-bar>
</div>

<div class="integration-main-container">
  <app-integration-sidebar-button class="integration-sidebar"></app-integration-sidebar-button>
  <div class="integration-content">
    <mat-card class="integration-section">
      <h1>User Manual - Integration Tool</h1>

      <mat-card-header>
        <mat-icon mat-card-avatar>warning</mat-icon>
        <mat-card-title>Important User Responsibility Notice</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Each user is fully responsible for all actions performed in this integration interface
          (clone, update, integrate, delete, and publication steps).
        </p>
        <p>
          During any running operation, you must stay on the current page and wait for the action to
          finish.
        </p>
        <ul>
          <li><strong>Do not refresh the page</strong> while an action is running.</li>
          <li><strong>Do not close the tab or browser</strong> during execution.</li>
          <li><strong>Do not navigate to another page</strong> until completion is confirmed.</li>
        </ul>
        <p>
          We are not responsible for data inconsistencies, partial executions, or failures caused by
          page refresh, navigation changes, or browser interruption during an ongoing action.
        </p>
      </mat-card-content>

      <mat-card-header>
        <mat-icon mat-card-avatar>layers</mat-icon>
        <mat-card-title>Layer Management</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>This section explains how to manage cloned repositories and integrated layers:</p>
        <ul>
          <li>
            <strong>Clone repository:</strong> Use the "Clone" button and provide a valid repository
            URL.
          </li>
          <li>
            <strong>Update repository:</strong> Click "Update" to pull latest changes from the
            linked repository.
          </li>
          <li>
            <strong>Run layer integration:</strong> Click "Layer Integration" to start the full
            integration workflow.
          </li>
          <li>
            <strong>View integration history:</strong> Click "Integration History" to inspect each
            step status.
          </li>
          <li>
            <strong>Delete integration:</strong> Click "Delete" to remove the repository from the
            database and unclone it.
          </li>
          <li>
            <strong>Manual refresh:</strong> Use the "Refresh" button to reload list/history when
            required.
          </li>
        </ul>
      </mat-card-content>

      <mat-card-header>
        <mat-icon mat-card-avatar>timeline</mat-icon>
        <mat-card-title>Integration Execution Order</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>The integration process follows this order to guarantee consistency:</p>
        <ol>
          <li><strong>Into DB:</strong> Layer data is loaded into the database.</li>
          <li><strong>Stats precompute:</strong> Pre-computation and statistics are generated.</li>
          <li><strong>GeoServer TIFF:</strong> TIFF processing and preparation are executed.</li>
          <li><strong>GeoServer Pyramid TIFF:</strong> Pyramid generation is performed.</li>
          <li>
            <strong>Deployment GeoServer:</strong> Final publication and deployment are executed.
          </li>
        </ol>
        <p>
          Status meaning:
          <br />
          <strong>Success</strong> means completed, <strong>Failed</strong> means the step failed,
          <strong>Not processed</strong> means the step has not started yet or will not be executed
          due to a previous failure or the layer type (e.g., vector layers integrations don't
          execute step 3 and 4).
        </p>
      </mat-card-content>

      <mat-card-header>
        <mat-icon mat-card-avatar>bug_report</mat-icon>
        <mat-card-title>Logs and Troubleshooting</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>The logs interface helps diagnose errors and verify execution details:</p>
        <ul>
          <li>Open the <strong>Logs</strong> tab to inspect system and integration messages.</li>
          <li>
            Check timestamps and error details before re-running a failed operation.
            <strong>Important:</strong> The timestamps are in Zulu Time (UTC+0), if you are in a
            different time zone, adjust accordingly.
          </li>
          <li>If an action fails, do not chain multiple retries immediately; review logs first.</li>
        </ul>
      </mat-card-content>

      <mat-card-header>
        <mat-icon mat-card-avatar>contact_support</mat-icon>
        <mat-card-title>Support</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>In case of issues or questions:</p>
        <ul>
          <li><strong>Email:</strong> {{ contactEmail }}</li>
          <li><strong>Documentation:</strong> Consult the project wiki for detailed guides.</li>
        </ul>
        <p>
          Please provide detailed context: screenshots, exact error messages, action type, layer
          name, repository name, and time of execution.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
